module.exports = __webpack_public_path__ + "static/img/IndiaIcon.bb916c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Menu/IndiaIcon.svg
// module id = /RJ5
// module chunks = 0